<ng-template #notificationTemplate let-data="data">
  <div class="ml-notification__body">
    <ng-container *ngIf="data.type === notificationType.SUCCESS">
      <img src="/assets/icons/notif-success.svg" alt="Success icon">
    </ng-container>
    <ng-container *ngIf="data.type === notificationType.ERROR">
      <img src="/assets/icons/notif-error.svg" alt="Error icon">
    </ng-container>
    <p class="ml-notification__text" [innerHTML]="data.message"></p>
  </div>
</ng-template>

<ng-template #notificationCloseSuccess>
  <img src="/assets/icons/close-green.svg" alt="Close icon">
</ng-template>

<ng-template #notificationCloseError>
  <img src="/assets/icons/close-red.svg" alt="Close icon">
</ng-template>